import React, {useState} from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import Wrp from '../../hoc/Wrp/Wrp';
import InputsField from '../../Components/FieldsInput/Inputs';
import Icons from '../../Components/Icons/Icons';
import {isSet} from '../../Utils/CommonFunctions';
import DrillDown from '../../Components/DrillDown';
import DropDownSearch from '../../Components/DropDownSearch';
import { callPOST } from '../../Utils/ApiUtil';
import {parameterizedURLAccessToken} from '../../Utils/CommonFunctions';

const FilterToggle = (props) => {
	const {htmlContentItems,currentElement} = props;
	//console.log('props.showFiltrtOpen',props.showFiltrtOpen)
	let showThis = "";
	if(props.showFilterOpen===true){
		showThis = "open";
	}

	let index = 0;
	let conditions = currentElement.data.conditions;
	let windowFields = isSet(props.windowFields,{});


	const setMultiSelectChanges = useState(false);

    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = (i, selectedOption) => {
	    // setSelectedOption(selectedOption[0]);
	    // props.handleConditionsMultiSelectInputChange(i,selectedOption);
  	};

	const handleChangeMultiple = (i, selectedOption) => {
		console.log(i, selectedOption);
	    // setSelectedOption(selectedOption[0]);
	    props.handleConditionsMultiSelectInputChange(i,selectedOption);
  	};

	let ruleOptions = '';
	const filterOnChange = (e,i,mode,isMultiSelect,valueIndex=0) => {
		// console.log(e,i,mode,isMultiSelect,valueIndex, 'filterOnChangefilterOnChange')
		let datevalue = '';
		let dateSysvalue = '';
		let value = [];
		if(e === '') {
			datevalue = '';
		}else if(mode === 'Date') {
			datevalue = e.format ? e.format('yyyy-MM-DD') : e ; 
		}else if(mode === 'DateTime') {
			datevalue = e.format ? e.format('yyyy-MM-DD HH:mm:ss') : e ;
		}else if(mode === 'inputField') {
			datevalue = e.target.value;
		}else if(mode === 'time') {
			datevalue = e;
		}else if(mode === 'percentage') {
			datevalue = e.target.value;
			if(datevalue > 100) {
				return false;
			}
		}
		if(isMultiSelect === true || isMultiSelect === 'true') {
			value = [{
				value : valueIndex === 0 ? datevalue : props.conditionList[i].values ? props.conditionList[i].values[0].value : ''
			},{
				value : valueIndex === 1 ? datevalue : props.conditionList[i].values ? props.conditionList[i].values[1].value : ''
			}]
		}else {
			value = [{
				value : datevalue,
			}]
		}
		console.log(value,valueIndex)
		props.handleConditionsMultiSelectInputChange(value,i);
	}

	
	const fieldOnChange = (fieldData, index) => {
		props.drillDownHandleConditionsInputChange(fieldData, index);
	}

	const checkViolations = (index,data,isValue=false,valueIndex=0) => {
		const violations = props.violations;
		let returnVal = false;
		let type = isValue === true ? 'rules['+index+'].values['+valueIndex+'].'+data : 'rules['+index+'].'+data;
		if(violations) {
			if(violations[type]){
				returnVal = true;
			}
		}	
		return returnVal;
	}

	const getViolationMsg = (index,data,isValue=false,valueIndex=0) => {
		const violations = props.violations;
		let returnVal = '';
		// let type = 'rules['+index+'].'+data;
		let type = isValue === true ? 'rules['+index+'].values['+valueIndex+'].'+data : 'rules['+index+'].'+data;
		if(violations) {
			if(violations[type]){
				returnVal = violations[type];
			}
		}	
		return returnVal;
	}

	const handleInputChange = (val,ind,data) => {
		let existVal = data.values ? data.values :[];
		existVal.push(val);
		props.handleConditionsMultiSelectInputChange(existVal,ind);
	}

	 const handleDelete = (i,ind,data) => {
        let existVal = data.values;
        existVal.splice(i,1);
        props.handleConditionsMultiSelectInputChange(existVal,ind);
    }

    const onFileChange = (e,i) => { 
	    props.Loader(true);
		const files = e.target.files;
		Object.entries(files).map(([key, fileItem]) => {
			const formData = new FormData();            
			formData.append("upload_file", fileItem);
			const APIURL = 'files/upload';
			callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
			.then(res => {    
			    props.Loader(false);
			    if(res.status==200){                        
			        const response = res.data;
			      if(response.code===200){
			          const responseData =  response.data; 
			          props.handleConditionsMultiSelectInputChange([{label:fileItem.name,value : responseData}],i);    
		              // const updateState = { ...this.state };
		              // updateState.adduserFormFields.profile_avatar.value = responseData;
		              // this.setState(updateState);
			        }else{
			          props.failMessage((res.message!=='')?res.message:'Something went wrong..');
			        }                                                
			    }else{
			        // this.props.Loader(false);
			        props.failMessage('Something went wrong..');
			    }
			})
			.catch(err => {
			    props.Loader(false);
			    props.failMessage('Something went wrong..');                    
			})
		})
  	}

  	const removeFileHandler = (i) => {
  		props.handleConditionsMultiSelectInputChange([],i);
  	}

  	const callDownloadFile = (fileID) => {
        let APIURL = 'files/download?fileId='+fileID;
        document.location.href = parameterizedURLAccessToken(APIURL);
    }
	
 	//console.log('conditions===',conditions)
 	//console.log('props.windowFields===',props.windowFields)
 	let getwindowFields = props.windowFields;
 	let exeptionValue = ['Lookup','MultiLookup','Multiselect','PickList']; 	
 	let windowFieldsFromFilters = isSet(getwindowFields,{fields_with_filters:{window_fields:[]}}).fields_with_filters.window_fields; 
 	let newWindowFields = [];
	windowFieldsFromFilters.map((item,index)=>{
		//field_type
		if(exeptionValue.indexOf(item.field_type)===-1){
			newWindowFields.push(item);
		}	
	}) 
	//console.log('windowFieldsFromFilters==',windowFieldsFromFilters,newWindowFields)
	let newWindowFieldsObj = {
		...getwindowFields,
		fields_with_filters:{
			...getwindowFields.fields_with_filters,
			window_fields:newWindowFields
		}
	}

	return(
		<>
			<div>
				<div className="title d-flex align-item-center justify-content-between">
		         	<div className="">Add Condition</div>
		         	<a className="cursor-pointer text-white" onClick={e=>props.addRulesRow()}>
		         		<i className="fas fa-plus primary_color"></i>
		         		<span className="text-medium"> Add New </span>
		         	</a>
		      	</div>
		      	<div className="view view-xl" style={{"height":"calc(-55px + 100vh)"}}>
		      		<div className="table_Box">
			            <div className="table_Body">
			               <div className="switch-block workFlow_rules">
			                  <div className="btnSwitch m-0">
			                     <div className="form-group">
			                           <ol className="workFlow_Count">

			                           		{
			                           			isSet(conditions,[]).map((x,i) => {
				                           			let filterOptions = [];
													if(x.fieldFilter){ 
														x.fieldFilter.map((data, i) => {
															if(data.used_modules_enum === 0 || data.used_modules_enum === 1){ 
																if(data.name !== 'is changed'){
																	filterOptions.push({label:data.name,value:data.filterId})
																}
															}
														})
													}

													let val = '';
								                    if(x.fieldType === 'MultiSelect' || x.fieldType === 'PickList' || x.fieldType === 'MultiLookup') {
								                        val = x.values ? x.values : [];
								                    }else {
								                    	if(x.values) {
								                    		if(x.values[0]) {
								                				val=x.values[0].value;
								                    		}else {
								                    			val = "";
								                    		}
								                    	}
								                    }

								                    const newFilterOptions = filterOptions.filter(x => x.label==='is equal to' || x.label==='is not equal to');


								                    													
										    		return (
										    			<Wrp key={i}>
												        	{i !== 0 ?
															<div className="label-align-center p-1">
																<div className="selectgroup">
																	<label className="selectgroup-item mb-0">
																		<input type="radio" name={"logicalOperator"+i} value="AND" className="selectgroup-input" onChange={e => props.handleCondiotnOperandInputChange(e, i)} checked={x.logicalOperator === "AND" ? true : false}/>
																		<span className="selectgroup-button selectgroup-button-icon padding025"> <small>AND</small> </span>
																	</label>
																	<label className="selectgroup-item mb-0">
																		<input type="radio" name={"logicalOperator"+i} value="OR" className="selectgroup-input" onChange={e => props.handleCondiotnOperandInputChange(e, i)} checked={x.logicalOperator === "OR" ? true : false}/>
																		<span className="selectgroup-button selectgroup-button-icon padding025"> <small> OR </small></span>
																	</label>
																</div>
															</div>
															: null
															}
															<li className="workFlow_conditions workFlow-row position-relative">
															
																<span className="workflow-inc">{i+1}</span>
														 		<div className="clearfix">
																<div className="col-12 col-md-3 float-left">
																	<input type="hidden" name="ruleId" value={x.ruleId} />
																	<DrillDown selectedValue={x.absolute_window1} drillId={"drill"+i} 
																		fieldDetails={newWindowFieldsObj} 
																		selectHandler={e=>fieldOnChange(e,i)} 
																		//isDisable={props.stage.conditionsStageDone}
																		isConditionApplied={true}
																		filterWindow={true}
																		>
												                            <input type="text" className="form-control col custom-arrow"  />
												                    </DrillDown>
												                    {/*
												                    	checkViolations(i,'fieldTypeId') === true ?
												                    	<label className="error m-0">{getViolationMsg(i,'fieldTypeId')}</label>
												                    	: null
												                    */}
																</div>
																<div className="workflow-rules-group">
																<div className="col-12 col-md-3 float-left">
																	<div className="col-12 col-md-2 float-left">
																	{
																		x.tableDescriptorId !== '' ?
																		<Wrp>
																		<DropDownSearch
																			options={newFilterOptions}
																			values={x.fieldFilterId}
																			changeHandler={e=>props.selectChangeHandler(e,"fieldFilterId",'conditionDetails',i,'',x.fieldType)}
																			//isDisable={props.stage.conditionsStageDone}
																		/>
																		{/*
																			checkViolations(i,'fieldFilterId') === true ?
													                    	<label className="error m-0">{getViolationMsg(i,'fieldFilterId')}</label>
													                    	: null
													                    */}
																		</Wrp>
																		: 
																		null
																	}
																	</div>
																
																	</div>
																	
																	<div className="col-12 col-md-3 float-left">
									                                        {x.table_descriptor_id !== '' && x.filterObject && x.filterObject.input_value_type ?
									                                        <Wrp>  
										                                        <div className="col">
										                                        { x.fieldType === 'FileUpload1111' || x.fieldType === 'ImageUpload23222' ?
										                                        	<div className="col-md-6 p-0">
												                                     	<input type="file" className="form-control-file" id="fileInput" onChange={e=>onFileChange(e,i)}/>
													                                    { x.values && x.values.length > 0 ? 
													                                    	<label className="list-group-header  pl-0 text-info">{x.values && x.values.length > 0 ? x.values[0].label : ''}
													                                    		<span onClick={e=>callDownloadFile(x.values[0].value)}><i className="pl-1 fa fa-download" /></span>
													                                    		<span onClick={e=>removeFileHandler(i)}> <Icons iconType="Delete" /></span>
													                                    	</label>
													                                    : null}
													                                </div>
										                                        : <InputsField 
										                                            attr1={i} 
										                                            attr4={x.filterObject.has_multiple_input ? 1 : 0 } 
										                                            filterOnChange={filterOnChange} 
										                                            handleChange={handleChange}
										                                            handleChangeMultiple={handleChangeMultiple}
										                                            value={ val } 
										                                            fieldtype={x.fieldType} 
										                                            filterObject={x.filterObject}
										                                            options={x.multiSelectOptions}
										                                            attr5={0}
										                                            lookupWindowName={x.lookupWindowName}
										                                            lookupWindowNameId={x.lookupWindowNameId}
										                                            handleInputChange={e=>handleInputChange(e,i,x)}
										                                            handleDelete={e=>handleDelete(e,i,x)}
										                                            values={x.values}
									                                            	/>}
										                                            
										                                            {/*
										                                            	checkViolations(i,'value',true,0) === true ?
																                    	<label className="error m-0">{getViolationMsg(i,'value',true,0)}</label>
																                    	: null
																                	*/}
										                                        </div>
										                                        {x.filterObject && (x.filterObject.has_multiple_input === true || x.filterObject.has_multiple_input === 'true') ? 
										                                        	<div className="col">
										                                                <InputsField 
										                                                    attr1={i} 
										                                                    attr4={x.filterObject.has_multiple_input ? 1 : 0 } 
										                                                    filterOnChange={filterOnChange} 
										                                                    handleChange={handleChange}
										                                                    handleChangeMultiple={handleChangeMultiple}
										                                                    value={ x.values ? x.values[1] ? x.values[1].value : '' : ''} 
										                                                    fieldtype={x.fieldType} 
										                                                    filterObject={x.filterObject}
										                                                    options={x.multiSelectOptions}
										                                                    attr5={1}
										                                                    lookupWindowName={x.lookupWindowName}
										                                                    lookupWindowNameId={x.lookupWindowNameId}
										                                                    handleInputChange={e=>handleInputChange(e,i,x)}
										                                                    handleDelete={e=>handleDelete(e,i,x)}
										                                                    values={x.values}
										                                                    />
										                                                {/*
										                                                	checkViolations(i,'value',true,1) === true ?
																	                    	<label className="error m-0">{getViolationMsg(i,'value',true,1)}</label>
																	                    	: null
																	                    */}
										                                             </div>
										                                        : null } 
									                                        </Wrp>  	                                                             
									                                        : null }
																	</div>
																</div>
																<div className="col-1 text-right pull-right">
																{
																	conditions.length !== 1 &&
																	<a onClick={() => props.handleConditionsRemoveClick(i)} className="cursor-pointer">
																		{/* <i className="far fa-trash-alt third_light_color"></i> */}
																		<Icons iconType="Delete" />
																	</a>
														        }
																</div>
															</div>
															</li>
															
														</Wrp>
										    		)
								    			})
											}
			                           					                              
			                           </ol>
			                        </div>
			                  </div>
			               </div>
			            </div>
			            <div className="table_Footer">
			            	<a className="btn btn-cancel filterToggle" onClick={e=>props.showFilterContent(false)}>Cancel </a>
			            	<a className="btn primary_bg" onClick={e=>props.applyFilterContent()}>Apply</a>
			            </div>
			        </div>
			    </div>
		    </div>
				
		</>
	)	
}


export default FilterToggle;